module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/promise.js